import getApiClient from "../../../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications
} from "../../../../../notifications/ducks/actions";

export const FETCH_TASK_STATUSES_ORDER = "FETCH_TASK_STATUSES_ORDER";
export const UPDATE_TASK_STATUSES_ORDER = "UPDATE_TASK_STATUSES_ORDER";
export const REORDER_TASK_STATUSES_ORDER = "REORDER_TASK_STATUSES_ORDER";
export const TASK_STATUSES_ORDER_SET_PRISTINE = "TASK_STATUSES_ORDER_SET_PRISTINE";

export function fetchTaskStatusesOrder(filmId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_TASK_STATUSES_ORDER,
      payload: getApiClient().get(`/film/${filmId}/taskStatus`)
    });
  };
}

export function updateTaskStatusesOrder(filmId, taskStatuses) {
  const command = { taskStatusesOrder: taskStatuses.map(s => { return { id: s.id } }) };
  return (dispatch) => {
    dispatch({
      type: UPDATE_TASK_STATUSES_ORDER,
      payload: getApiClient().put(
        `/film/${filmId}/taskStatus/order`,
        command
      ),
      meta: { taskStatuses }
    })
      .then((response) => {
        dispatch(showInfo(`Updated task statuses order`));
      })
      .catch((response) => {
        dispatch(showError(`Error updating task statuses order`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function updateOrder(startIndex, endIndex) {
  return (dispatch) => {
    dispatch({
      type: "REORDER_SCENES_SCRIPT_DAYS",
      meta: { startIndex, endIndex }
    });
  };
}

export function updateTaskStatusOrder(
  startIndex,
  endIndex,
  sourceDay,
  destinationDay
) {
  return (dispatch) => {
    dispatch({
      type: REORDER_TASK_STATUSES_ORDER,
      meta: { startIndex, endIndex, sourceDay, destinationDay }
    });
  };
}

export function clearRedirect(dispatch) {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_REDIRECT"
    });
  };
}

export function toggleSelectionInGroup(sceneId) {
  return (dispatch) => {
    dispatch({
      type: "SCENES_SCRIPT_DAY_TOGGLE_SELECTION_IN_GROUP",
      meta: { sceneId }
    });
  };
}

export function multiSelectTo(sceneId) {
  return (dispatch) => {
    dispatch({
      type: "SCENES_SCRIPT_DAY_MULTI_SELECT_TO",
      meta: { sceneId }
    });
  };
}

export function setDraggingSceneId(sceneId) {
  return (dispatch) => {
    dispatch({
      type: "SCENES_SCRIPT_DAY_SET_DRAGGING_SCENE_ID",
      meta: { sceneId }
    });
  };
}

export function unselectAll() {
  return (dispatch) => {
    dispatch({
      type: "SCENES_SCRIPT_DAY_UNSELECT_ALL"
    });
  };
}

export function setPristine() {
  return (dispatch) => {
    dispatch({
      type: TASK_STATUSES_ORDER_SET_PRISTINE
    });
  };
}